module.exports = __webpack_public_path__ + "static/img/1.c52afd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/1.png
// module id = GWYf
// module chunks = 0